import { render, staticRenderFns } from "./vimeo-authorize.vue?vue&type=template&id=6582ba81&scoped=true&"
import script from "./vimeo-authorize.vue?vue&type=script&lang=js&"
export * from "./vimeo-authorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582ba81",
  null
  
)

export default component.exports